
<template>
  <b-card :title="$t(chartData.title)">
    <b-row>
      <b-col
        :id="alias"
        :lg="typeOfChart"
        md="12"
        sm="12"
        class="chart"
        :style="{ minHeight: height }"
      />
      <b-col :lg="typeOfChart" md="12" sm="12" class="table">
        <b-table :items="data" :fields="fields" outlined>
          <template v-for="field in fields" #head(field.key)="">
            {{ $t(labels[field.key]) }}
          </template>

          <template #cell(convention)="row">
            <div
              class="convention"
              :style="{ backgroundColor: $t(row.item.label + '_color') }"
            />
          </template>
          <template #cell(label)="row">
            {{ $t(row.item.label) }}
          </template>
          <template #cell(value)="row">
            {{ row.item.value
            }}{{
              row.item.percentage !== undefined
                ? ` (${(row.item.percentage * 100).toFixed(2)}%)`
                : ""
            }}
          </template>
        </b-table>
        <template #head(convention)="" />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { ChartPie } from "@/utils/ChartPie";
import { ChartBarStackedHorizontal } from "@/utils/ChartBarStackedHorizontal";
import { mapGetters } from "vuex";

export default {
  name: "CardChartOpinionSurvey",
  props: {
    alias: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
    section: {
      type: String,
      default: "",
    },
    question: {
      type: String,
      default: "",
    },
    filterCriteria: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "participation",
    },
    typeOfChart: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      chartData: {},
      fields: [],
      data: [],
    };
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      svg.selectAll(".chart").remove();
      setTimeout(() => {
        this.updateData();
      }, 200);
    },
  },
  methods: {
    updateData() {
      this.questionData = this.getOpinionSurveyQuestionData(
        this.section,
        this.question,
        this.filterCriteria
      );
      if (this.type === "participation") {
        // Calculate the percentage
        const chartData = this.questionData.participationChart.data;
        const dataValues = {};
        for (const question of chartData) {
          dataValues[question.label] = question.value;
        }
        chartData.forEach((item) => {
          // Calculates the total of the elements
          const total = this.getTotal(dataValues);
          if (total !== 0) {
            item.type = "integer";
            item.percentage = (100 * item.value) / total / 100;
          }
        });
        this.chartData = this.questionData.participationChart;
      } else {
        // Calculate the percentage
        const chartData = this.questionData.responsesChart.data;
        const dataValues = {};
        for (const question of chartData) {
          for (const group of question.group) {
            dataValues[group.label] = dataValues[group.label] || {};
            dataValues[group.label][question.label] = group.value;
          }
        }
        chartData.forEach((labels) => {
          labels.group.forEach((groups) => {
            // Calculates the total of the elements
            const total = this.getTotal(dataValues[groups.label]);
            if (total !== 0) {
              groups.percentage = ((100 * groups.value) / total).toFixed(2);
            }
          });
        });
        const yAxis = this.questionData.responsesChart.xAxis;
        const xAxis = this.questionData.responsesChart.yAxis;
        this.questionData.responsesChart.xAxis = xAxis;
        this.questionData.responsesChart.yAxis = yAxis;
        this.chartData = this.questionData.responsesChart;
      }
      this.updateChart();
      this.updateTable();
    },
    getTotal(entries) {
      return Object.entries(entries).reduce((accumulator, currentData) => {
        const [, value] = currentData;
        return accumulator + value;
      }, 0);
    },
    updateChart() {
      if (this.type === "participation") {
        this.chart = new ChartPie(this.alias, this.chartData, 80);
      } else {
        this.chart = new ChartBarStackedHorizontal(
          this.alias,
          this.chartData,
          true,
          true
        );
      }
      this.chart.render();
    },
    updateTable() {
      if (this.type === "participation") {
        this.labels = {
          convention: "",
          label: this.chartData.xAxis,
          value: this.chartData.yAxis,
        };
        this.fields = [
          { key: "convention" },
          { key: "label" },
          { key: "value" },
        ];
        this.data = this.chartData.data;
      } else {
        this.labels = {
          convention: "",
          label: this.chartData.yAxis,
        };
        this.fields = [{ key: "convention" }, { key: "label" }];
        this.chartData.data.map((i) => {
          this.fields.push({ key: i.label });
          this.labels[i.label] = i.label;
        });

        // Agregamos los labels necesarios
        var labels = [];
        this.chartData.data[0].group.map((i) => {
          labels.push(i.label);
        });

        this.data = [];

        labels.map((i) => {
          var obj = {
            label: i,
          };
          this.chartData.data.map((j) => {
            j.group.map((k) => {
              if (i === k.label) {
                obj[j.label] = `${k.value} ${
                  k.percentage !== undefined ? ` (${k.percentage}%)` : ""
                }`;
              }
            });
          });
          this.data.push(obj);
        });
      }
      this.fields = Object.keys(this.labels).map((s) => {
        return {
          key: s,
          label: this.$t(this.labels[s]),
        };
      });
    },
  },
  computed: mapGetters(["getOpinionSurveyQuestionData"]),
  mounted() {
    this.updateData();
  },
};
</script>
<style lang="sass" scoped>
/* components/cards/CardChartOpinionSurvey.vue */

@import '../../assets/css/variables.scss'

.card-body
  flex: none
  font-family: $font-subtitle
  height: 100%

.card-title
  text-align: center

.b-table
  font-family: $font-text
  font-size: 0.8rem
  margin-top: 1rem

.convention
  background-color: #000
  width: 1.5rem
  height: 1.5rem
  margin: 0
</style>
